import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import MainHeader from "../Layout/Header";
import Footer from "../Layout/Footer";
import "./style.css";

function AboutUs() {
  return (
    <Container fluid className="presale-live-background">
      <MainHeader />
      <Container className="about-us-container">
        <Row className="justify-content-center">
          <Col md={10} lg={10}>
            {/* Main Title */}
            <Row className="mb-0">
              <Col>
                <h1 className="about-us-title">About Us</h1>
              </Col>
            </Row>

            {/* Introduction */}
            <Row className="mb-5">
              <Col>
                <p className="about-us-intro">
                  Trinity is a community-owned Web3 ecosystem at the
                  intersection of AI and blockchain, built to empower smarter
                  trading, deeper ownership, and perpetual earnings.
                </p>
              </Col>
            </Row>

            {/* Three Pillars Section */}
            <Row className="mb-5">
              <Col>
                <h2 className="about-us-subtitle">
                  We unite three powerful pillars:
                </h2>
              </Col>
            </Row>

            <Row className="mb-5 pillars-row">
              <Col md={4} className="mb-4 mb-md-0">
                <Card
                  className="pillar-card"
                  onClick={() => window.open("https://bullflag.fun/", "_blank")}
                  style={{ cursor: "pointer" }}
                >
                  <Card.Body>
                    <h3 className="pillar-title">BullFlag</h3>
                    <p className="pillar-description">
                      AI-powered trading bots that scan X trends, whale moves,
                      and market signals to execute ultra-fast trades on Solana
                      via Jupiter.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} className="mb-4 mb-md-0">
                <Card className="pillar-card">
                  <Card.Body>
                    <h3 className="pillar-title">TokenEye</h3>
                    <p className="pillar-description">
                      Real-time Web3 intelligence delivering actionable alerts
                      and dashboards (launching Q1 2026).
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card
                  className="pillar-card"
                  onClick={() => window.open("https://aitellit.com/", "_blank")}
                  style={{ cursor: "pointer" }}
                >
                  <Card.Body>
                    <h3 className="pillar-title">AiTellit</h3>
                    <p className="pillar-description">
                      Our live social-AI hub for sharing insights, learning, and
                      community amplification.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* TRT Section */}
            <Row className="mb-5">
              <Col>
                <Card className="trt-card">
                  <Card.Body>
                    <h2 className="about-us-subtitle mb-4">
                      Trinity Tether (TRT)
                    </h2>
                    <p className="about-us-text">
                      At the core is <strong>Trinity Tether (TRT)</strong> — a
                      BEP-20 token that gives holders up to 60% of BullFlag's
                      global revenue, paid monthly. TRT is exchange-ready for
                      instant liquidity, with multichain support coming soon.
                      Affiliates earn 50% commissions across three tiers, paid
                      instantly in BNB.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Launch Info */}
            <Row className="mb-5">
              <Col>
                <p className="about-us-text">
                  Launched softly in December 2025, we're scaling fast with real
                  revenue, audited transparency, and community-first design.
                  Trinity isn't just a platform — it's ownership in the future
                  of AI-driven crypto.
                </p>
              </Col>
            </Row>

            {/* Call to Action */}
            <Row className="mb-5">
              <Col>
                <div className="cta-section">
                  <p className="cta-text">
                    Join us. Trade smarter. Own more. Earn always.
                  </p>
                  <p className="cta-footer">Forward together.</p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </Container>
  );
}

export default AboutUs;
